import { Link } from 'react-router-dom';
import { 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  // TableHead, 
  TableRow, 
  Typography, 
  Button 
} from '@mui/material';

const Toc = () => {
  const models = [
    {
      name: 'Users',
      description: 'System users, human beings with logins and password credentials.',
      link: '/users'
    },
    {
      name: 'Employees',
      description: 'Users who work at stores have employee records, for store specific settings.',
      link: '/employees'
    },
    {
      name: 'Companies',
      description: 'Parent companies own stores and have billing information with Zignyl.  Configure API settings and enable modules here.',
      link: '/companies'
    },
    {
      name: 'Stores',
      description: 'Brick and mortar locations, with employees and operating hours.',
      link: '/stores'
    }
  ];

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>Table of Contents</Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">

          <TableBody>
            {models.map((model) => (
              <TableRow key={model.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="right">
                    <Button component={Link} to={model.link} variant="text" fullwidth='true'>
                    {model.name}
                    </Button>
                </TableCell>
                <TableCell align="right">{model.description}</TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Toc;
